.aj{flex-wrap:wrap;}